import React from "react";

import { goTo, useNavigate } from "utils";

import { Card, Col, Icon, Row, Typography } from "components";

export const Alerts = ({ alerts }) => {
  const navigate = useNavigate();

  return (
    <section className="container">
      <Row>
        {/* prelint-ignore-col */}
        {alerts.verifications > 0 && (
          <Col sm={24} md={8}>
            <Card className="content-card red margin-0" onClick={(e) => goTo(e, navigate, "/farms/verifications")}>
              <div className="icon-container">
                <Icon iconName="tabler/trophy" size="m" color="white" />
              </div>
              <div className="content">
                <Typography variant="h5" color="white">
                  {alerts.verifications} pending verifications
                </Typography>
                <Typography variant="paragraph-s">Click me to review all verifications</Typography>
              </div>
            </Card>
          </Col>
        )}
        {alerts.invekos > 0 && (
          <Col sm={24} md={8}>
            <Card bordered={false} className="content-card orange margin-0" onClick={(e) => goTo(e, navigate, "/farms/shapefiles")}>
              <div className="icon-container">
                <Icon iconName="tabler/file" size="m" color="white" />
              </div>
              <div className="content">
                <Typography variant="h5" color="white">
                  {alerts.invekos} recent unprocessed shapefiles
                </Typography>
                <Typography variant="paragraph-s">Click me to view all shapefiles</Typography>
              </div>
            </Card>
          </Col>
        )}
      </Row>
    </section>
  );
};
